import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["title", "content", "visible", "children", "titleStyle", "hideHeader", "className", "hideFooter", "hideCloseIcon", "width"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import _constant from 'lodash/constant';
// import Tooltip from antd atoms/tooltip as it has a default title prop as Untitled
// and it shows up on each modal if title is not passed
import { Modal, Tooltip } from 'antd';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { getScaleAdjustedSize } from '../../utils/general';
import Button from '../../atoms/Button';
import styles from './modal.module.scss';
// Constants
import SIZES from './constants/modal.sizes';
var TModal = /*#__PURE__*/function (_React$Component) {
  _inherits(TModal, _React$Component);
  var _super = _createSuper(TModal);
  function TModal() {
    var _this;
    _classCallCheck(this, TModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getFooterActionButtons", function () {
      var _this$props = _this.props,
        hideCancel = _this$props.hideCancel,
        submitBtnText = _this$props.submitBtnText,
        hideSubmit = _this$props.hideSubmit,
        secondaryBtnText = _this$props.secondaryBtnText,
        okButtonProps = _this$props.okButtonProps,
        cancelButtonProps = _this$props.cancelButtonProps,
        onCancel = _this$props.onCancel,
        onSubmit = _this$props.onSubmit,
        loading = _this$props.loading,
        id = _this$props.id,
        onSecondarySubmit = _this$props.onSecondarySubmit,
        secondaryBtnLoading = _this$props.secondaryBtnLoading,
        renderFooterLeftSection = _this$props.renderFooterLeftSection,
        primaryBtnDisabled = _this$props.primaryBtnDisabled,
        renderFooterRightSection = _this$props.renderFooterRightSection,
        primaryBtnTooltipProps = _this$props.primaryBtnTooltipProps,
        showFooter = _this$props.showFooter;
      if (!showFooter) {
        return null;
      }
      var leftSection = renderFooterLeftSection();
      var rightSection = renderFooterRightSection();
      return /*#__PURE__*/React.createElement("div", {
        className: cx(_defineProperty({}, styles.footerWrapper, leftSection)),
        id: id
      }, leftSection, /*#__PURE__*/React.createElement("div", {
        className: styles.footerRightSection
      }, rightSection, !hideCancel && /*#__PURE__*/React.createElement(Button, _extends({
        key: "cancel",
        onClick: onSecondarySubmit || onCancel,
        disabled: loading,
        loading: secondaryBtnLoading
      }, cancelButtonProps), secondaryBtnText), !hideSubmit && /*#__PURE__*/React.createElement(Tooltip, primaryBtnTooltipProps, /*#__PURE__*/React.createElement(Button, _extends({
        key: submitBtnText,
        view: "primary",
        onClick: onSubmit,
        loading: loading,
        disabled: secondaryBtnLoading || primaryBtnDisabled
      }, okButtonProps), submitBtnText))));
    });
    return _this;
  }
  _createClass(TModal, [{
    key: "render",
    value: function render() {
      var _cx2;
      var _this$props2 = this.props,
        title = _this$props2.title,
        content = _this$props2.content,
        visible = _this$props2.visible,
        children = _this$props2.children,
        titleStyle = _this$props2.titleStyle,
        hideHeader = _this$props2.hideHeader,
        className = _this$props2.className,
        hideFooter = _this$props2.hideFooter,
        hideCloseIcon = _this$props2.hideCloseIcon,
        width = _this$props2.width,
        rest = _objectWithoutProperties(_this$props2, _excluded);
      return /*#__PURE__*/React.createElement(Modal, _extends({
        visible: visible,
        centered: true,
        title: /*#__PURE__*/React.createElement("div", {
          className: styles.modalTitle,
          style: titleStyle
        }, title),
        footer: this.getFooterActionButtons(),
        className: cx(className, (_cx2 = {}, _defineProperty(_cx2, styles.hideHeader, hideHeader), _defineProperty(_cx2, styles.hideFooter, hideFooter), _defineProperty(_cx2, styles.hideCloseIcon, hideCloseIcon), _cx2)),
        width: getScaleAdjustedSize(width)
      }, rest), content || children);
    }
  }]);
  return TModal;
}(React.Component);
_defineProperty(TModal, "propTypes", {
  onCancel: PropTypes.func.isRequired,
  handleCancel: PropTypes.func,
  submitBtnText: PropTypes.string,
  secondaryBtnText: PropTypes.string,
  okButtonProps: PropTypes.object,
  cancelButtonProps: PropTypes.object,
  loading: PropTypes.bool,
  renderFooterLeftSection: PropTypes.func,
  primaryBtnDisabled: PropTypes.bool,
  renderFooterRightSection: PropTypes.func,
  primaryBtnTooltipProps: PropTypes.object,
  showFooter: PropTypes.bool,
  width: PropTypes.number
});
_defineProperty(TModal, "defaultProps", {
  handleCancel: _noop,
  submitBtnText: __('Save'),
  secondaryBtnText: __('Cancel'),
  okButtonProps: EMPTY_OBJECT,
  cancelButtonProps: EMPTY_OBJECT,
  loading: false,
  renderFooterLeftSection: _constant(null),
  primaryBtnDisabled: false,
  renderFooterRightSection: _constant(null),
  primaryBtnTooltipProps: EMPTY_OBJECT,
  showFooter: true,
  width: SIZES.MD
});
_defineProperty(TModal, "SIZES", SIZES);
export default TModal;